<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    scrollable
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card class="colorDominant">
      <v-toolbar class="elevation-0 colorDominant">
        <v-toolbar-title>
          {{ actionName }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="text-center headline my-6">
        <v-progress-circular
          v-if="loading"
          indeterminate
          class="pa-6"
        ></v-progress-circular>

        <div>
          <v-icon :color="iconColor" style="font-size: 80px">
            {{ iconStatus }}
          </v-icon>
        </div>
        {{ msgStatus }}
      </v-card-text>

      <v-divider v-if="!logged"></v-divider>
      <v-card-actions v-if="!logged" class="pa-4">
        <div class="flex-grow-1"></div>
        <v-btn color="primary" @click="openDialogLogin">
          {{ $t("login") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "valid-register",
  data() {
    return {
      iconStatus: "",
      iconColor: "",
      msgStatus: "",
      loading: false,
      id_affilliate: "",
    };
  },
  mounted() {
    this.validRegister();
  },
  watch: {
    dialog(val) {
      if (val) this.validRegister();
    }
  },
  computed: {
    dialog() {
      return this.$store.state.showDialogPhoneOrEmailChangeConfirmation;
    },
    logged() {
      return this.$store.state.logged.status;
    },
    actionName() {
      const type = localStorage.getItem("actionType");

      if (!type) {
        return "";
      }

      if (type === "email") {
        return this.$t("changeContactInfo.emailAction");
      }

      return this.$t("changeContactInfo.phoneAction");
    },
  },
  methods: {
    validRegister() {
      // Fecha dialog de registro
      this.$store.commit("showDialogRegister", false);

      const hash = this.$route.query.cod ?
        this.$route.query.cod :
        this.$route.params.cod;

      if (hash) {
        this.$handleURLState("open_confirm_email_or_phone_change", "delete");
        this.$handleURLState("cod", "delete");
      } else {
        this.closeDialog();

        return;
      }

      const data = { code: hash, domain: this.$domain() };

      data.type = localStorage.getItem("actionType");
      
      this.loading = true;

      this.$axios
        .post("player/profile/editContact", this.$formdata(data))
        .then((resp) => {
          this.iconStatus = "mdi-account-check";
          this.iconColor = "success";
          this.msgStatus = resp.data.messages;
          this.id_affilliate = resp.data.dados.id_affilliate;
          var data = resp.data.dados;

          return data;
        })
        .catch((error) => {
          this.iconStatus = "mdi-alert-octagon";
          this.iconColor = "warning";
          this.msgStatus = error.response.data.messages.error;
        })
        .finally(() => {
          this.loading = false
        });
    },
    openDialogLogin() {
      this.closeDialog();
      this.$store.commit("setLoginDialog", true);
    },
    closeDialog() {
      this.$store.commit("showDialogPhoneOrEmailChangeConfirmation", false);
    },
  },
};

</script>